import { CarePlusDosageOption, CarePlusMedication } from "../ChooseTreatmentCarePlus/types";
import { firstChoosableDosage } from "../ChooseTreatmentCarePlus/useChooseTreatmentCarePlus";

// HL-12999: the "needs proof" dose notice on UK WL Choose Treatment. The server decides which doses get it
// (DoseNoticeManager, same rule as the HL-12997 proof task); null = no notice on this page.
export interface DoseNoticeData {
  customer_type: "new" | "returning";
  prior_use_current: string;
  prior_use_ever: string;
  // Product id of a dose that needs proof → the product of the same drug to switch to.
  products: Record<string, { allowed_product_id: number }>;
}

/** The dose the notice's switch selects, or null when the selected dose gets no notice. */
export const getDoseNoticeSwitchTarget = (
  doseNotice: DoseNoticeData | null,
  medication: CarePlusMedication | null,
  selected: CarePlusDosageOption | null,
): CarePlusDosageOption | null => {
  const allowedProductID = selected ? doseNotice?.products?.[selected.product_id]?.allowed_product_id : undefined;
  if (!allowedProductID || !medication) return null;
  return firstChoosableDosage(
    medication.dosages.filter((dosage) => dosage.product_id === allowedProductID),
    medication.is_pre_orderable,
  );
};
